import BaseClass from "../BaseClass.js";

export default class DynamicDropdown extends BaseClass {
    constructor(element) {
        super(element);
        this.dropdownClickListener = null;
        this.dropdownCloseListener = null;
        this.dropdownReloadListener = null;
        this.roomName = null;
        this.url = null;
        this.dropdownID = null;
        this.$dropdownList = null;
        this.isDropdownOpen = false;
        this.init();
    }

    init() {
        let mySelf = this;

        const roomName = this.$element.attr('data-room');
        if (roomName !== undefined) {
            this.roomName = roomName;
        }

        const url = this.$element.attr('data-url');
        if (url !== undefined) {
            this.url = url;
        }

        const dropdownList = this.$element.find('[data-type="viewers-list"]');
        if (dropdownList !== undefined) {
            this.$dropdownList = dropdownList;
        }

        const dropdownID = this.$element.attr('data-id');
        if (dropdownID !== undefined) {
            this.dropdownID = dropdownID;
        }

        this.dropdownClickListener = function (event) {
            mySelf.loadDropdownData();
        }

        this.dropdownCloseListener = function (event) {
            mySelf.closeDropdown();
        }

        this.dropdownReloadListener = function (event, data) {
            if (data && data.dropdownID) {
                if (data.dropdownID == mySelf.dropdownID) {
                    mySelf.reloadDropdown();
                }
            }
        }

        this.$element.on('show.bs.dropdown', this.dropdownClickListener);
        this.$element.on('hide.bs.dropdown', this.dropdownCloseListener);
        $(document).on('viewers:amount:changed', this.dropdownReloadListener);
    }

    loadDropdownData() {
        let mySelf = this;

        if (mySelf.url != null && mySelf.$dropdownList != null) {
            mySelf.isDropdownOpen = true;
            mySelf.$dropdownList.html('<p class="dropdown-item text-muted">Loading...</p>');

            $.post(mySelf.url, {room_name: mySelf.roomName}, function () {
            }, 'json')
                .done(function (response) {
                    mySelf.showViewersList(response);
                })
                .fail(function () {
                    mySelf.$dropdownList.html('<p class="dropdown-item text-danger">Fehler. Bitte erneut versuchen</p>');
                });
        }
    }

    showViewersList(response) {
        if (response.status == "success") {
            const users = response.data;

            this.$dropdownList.html('');

            if (users.length == 0) {
                this.$dropdownList.html('<p class="dropdown-item text-muted">No viewers</p>');
                return;
            }

            users.forEach(user => {
                let $viewerEntry = this.createViewerEntry(user);

                this.$dropdownList.append($viewerEntry.get(0));
            });
        } else {
            this.$dropdownList.html('<p class="dropdown-item text-danger">Fehler. Bitte erneut versuchen</p>');
        }
    }

    createViewerEntry(user) {
        let currentUrl = new URL(window.location);
        let userURL = currentUrl.origin + '/' + user.username;
        let $viewerContainer = this.getTemplate('js-stream_viewer_entry_tpl');
        $viewerContainer.find('[data-type="user-href"]').removeClass('hidden').addClass('user-avatar--green');

        let $username = $viewerContainer.find('[data-type="viewer-username"]');
        $username.html(user.username);

        let $userClock = $viewerContainer.find('[data-type="viewer-clock"]');
        $userClock.text(user.timeOnStream);

        let $userMoney = $viewerContainer.find('[data-type="viewer-money"]');
        $userMoney.text(user.current_amount + '/' + user.total_amount);

        let $link = $viewerContainer.find('[data-type="user-href"]');
        $link.attr('href', userURL);
        $link.attr('target', '_blank');

        let $avatar = $viewerContainer.find('[data-type="avatar-img"]');
        $avatar.attr('src', user.avatarSrc).attr('alt', user.username);

        return $viewerContainer;
    }

    reloadDropdown() {
        if (this.isDropdownOpen) {
            this.loadDropdownData();
        }
    }

    closeDropdown() {
        this.isDropdownOpen = false;
    }

    getTemplate(templateID) {
        let $template = $("#" + templateID).contents().filter(function () {
            return this.nodeType === 1;
        }).clone();
        if ($template.length == 0) {
            console.error("template " + templateID + " not found");
        }
        return $template;
    }

    destroyListener() {
        this.$element.off('show.bs.dropdown', this.dropdownClickListener);
        this.$element.off('hide.bs.dropdown', this.dropdownCloseListener);
        $(document).off('viewers:amount:changed', this.dropdownReloadListener);
    }
}